import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import axios from '../../axios/axiosconf';
import SuperadminSidebar from './SuperadminSidebar';
import './SuperadminStyles.css';

const SuperadminLayout = ({ children }) => {
    const history = useHistory();
    const [superadminUser, setSuperadminUser] = useState(null);

    useEffect(() => {
        // Verificar autenticación
        const token = localStorage.getItem('superadmin_token');
        const user = localStorage.getItem('superadmin_user');

        if (!token || !user) {
            history.push('/superadmin/login');
            return;
        }

        setSuperadminUser(JSON.parse(user));

        // Configurar axios con el token
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }, [history]);

    const handleLogout = async () => {
        try {
            await axios.post('/superadmin/logout');
        } catch (error) {
            console.error('Error during logout:', error);
        } finally {
            localStorage.removeItem('superadmin_token');
            localStorage.removeItem('superadmin_user');
            delete axios.defaults.headers.common['Authorization'];
            history.push('/superadmin/login');
        }
    };

    return (
        <div className="superadmin-dashboard">
            {/* Navbar */}
            <div className="superadmin-navbar">
                <div>
                    <h3><i className="fas fa-user-shield"></i> Panel de Superadministrador</h3>
                    <small>Bienvenido, {superadminUser?.nombre}</small>
                </div>
                <button className="btn btn-light" onClick={handleLogout}>
                    <i className="fas fa-sign-out-alt"></i> Cerrar Sesión
                </button>
            </div>

            <div className="container-fluid">
                <div className="row">
                    {/* Sidebar siempre minimizado */}
                    <div className="col-md-1">
                        <SuperadminSidebar />
                    </div>

                    {/* Content */}
                    <div className="col-md-11">
                        <div className="superadmin-content">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SuperadminLayout;
